<template>
  <div>
    <ok-cancel-modal
      :title="name"
      :ok-button="$t('commons.ok')"
      :cancel-button="$t('commons.cancel')"
      v-on:ok="onOk"
      v-on:cancel="$emit('close')">
      <div
        slot="body">

        <div class="variable-input-field variable-input-field-name">
          <label-input
            ref="domainInput"
            form-size="m"
            :label="$t('health.corporateGroups.domainWithoutAt')"
            v-model="domain"
            :type="'text'"
            :error="domainError"
            :errorMessage="$t('health.corporateGroups.invalidDomain')">
          </label-input>
        </div>

        <checkbox
          id="active-plan"
          :label="$t('health.corporateGroups.activePlan')"
          v-on:change="onActivePlanChange"
          :checked="activePlan">
        </checkbox>

      </div>
    </ok-cancel-modal>
  </div>
</template>

<script>
import LabelInput from '@/components/shared/forms/LabelInput';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import SearchInput from '@/components/shared/SearchInput';
import Checkbox from '@/components/shared/forms/Checkbox';

export default {
  name: 'EditCorporateGroupModal',
  components: {
    OkCancelModal,
    SearchInput,
    Checkbox,
    LabelInput
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    value: {
      handler: function (value) {
        this.name = value.name;
        this.domain = value.domain;
        this.activePlan = value.activePlan;
      },
      immediate: true
    }
  },
  data () {
    return {
      id: '',
      groupId: '',
      name: '',
      domain: '',
      activePlan: false,
      domainError: false
    };
  },
  created () {
    this.$nextTick(() => {
      this.$refs.domainInput.focus();
    });
  },
  methods: {
    onOk () {
      const updatedGroup = {
        id: this.value.id,
        groupId: this.value.groupId,
        name: this.value.name,
        domain: this.domain,
        activePlan: this.activePlan
      };
      this.$emit('input', updatedGroup);
      this.$emit('close');
    },
    onActivePlanChange (value) {
      this.activePlan = value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";

h3 {
  color: $jamaicol;
}

.plan-list {
  min-height: calc(100vh / 2);
  max-height: calc(100vh / 2);
  overflow-y: auto;
}

.search-input {
  margin-bottom: $sp-margin;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/corporateGroups/EditCorporateGroupModal.vue